export function pluralize(n: number) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 19) {
    return { verb: 'Создано', noun: 'заявок' };
  }
  if (mod10 === 1) {
    return { verb: 'Создана', noun: 'заявка' };
  }
  if (mod10 >= 2 && mod10 <= 4) {
    return { verb: 'Создано', noun: 'заявки' };
  }
  return { verb: 'Создано', noun: 'заявок' };
}
